import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="p-8 lg:p-24 flex flex-col lg:flex-row lg:justify-between bg-bg-darker bg-opacity-45 text-center lg:text-left">
    <div className="">
      <h4 className="text-lg lg:text-2xl border-b-2 border-black mb-2 block lg:inline-block ">
        find us
      </h4>
      <p>
        Willem Dreespark 312
        <br />
        2531 SX, The Hague
      </p>
    </div>
    <div className="">
      <h4 className="mt-5 lg:mt-auto text-lg lg:text-2xl border-b-2 border-black mb-2 block lg:inline-block ">
        contact us
      </h4>
      <p>
        <a
          className="hover:underline"
          href="mailto:info@instrumentinventors.org"
        >
          info@instrumentinventors.org
        </a>
      </p>
    </div>
    <div className="">
      <h4 className="mt-5 lg:mt-auto text-lg lg:text-2xl border-b-2 border-black mb-2 block lg:inline-block ">
        donate
      </h4>
      <p>
        <a
          className="hover:underline"
          href="https://shop.instrumentinventors.org/product/donation/"
          target="_blank"
        >
          click for more info
        </a>
      </p>
    </div>
    <div className="">
      <h4 className="mt-5 lg:mt-auto text-lg lg:text-2xl border-b-2 border-black mb-2 block lg:inline-block ">
        follow us
      </h4>
      <p className="flex justify-center lg:justify-start">
        <a
          href="https://www.facebook.com/instrumentinventors"
          target="_blank"
          className="mr-2 transform hover:scale-105"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            // className="fill-current hover:text-white"
          >
            <path
              d="M-1443.557,1838.041a20,20,0,0,0-20,20,20,20,0,0,0,20,20,20,20,0,0,0,20-20A20,20,0,0,0-1443.557,1838.041Zm5.874,12.133h-2.778c-.981,0-1.185.4-1.185,1.417v2.451h3.964l-.382,4.3h-3.581V1871.2h-5.133v-12.8h-2.67v-4.358h2.67v-3.432c0-3.221,1.722-4.9,5.542-4.9h3.555Z"
              transform="translate(1463.557 -1838.041)"
            />
          </svg>
        </a>
        <a
          href="https://www.instagram.com/instrumentinventors/"
          target="_blank"
          className="mr-2 transform hover:scale-105"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
          >
            <path
              d="M-2374.5,2077.18a3.573,3.573,0,0,0-.865-1.329,3.58,3.58,0,0,0-1.33-.865,6.407,6.407,0,0,0-2.147-.4c-1.219-.056-1.585-.067-4.672-.067s-3.453.011-4.673.067a6.408,6.408,0,0,0-2.147.4,3.572,3.572,0,0,0-1.329.865,3.56,3.56,0,0,0-.865,1.329,6.41,6.41,0,0,0-.4,2.147c-.056,1.219-.067,1.585-.067,4.673s.011,3.453.067,4.672a6.411,6.411,0,0,0,.4,2.147,3.559,3.559,0,0,0,.865,1.329,3.575,3.575,0,0,0,1.329.865,6.415,6.415,0,0,0,2.147.4c1.219.055,1.585.067,4.673.067s3.453-.012,4.672-.067a6.413,6.413,0,0,0,2.147-.4,3.583,3.583,0,0,0,1.33-.865,3.572,3.572,0,0,0,.865-1.329,6.408,6.408,0,0,0,.4-2.147c.056-1.219.067-1.585.067-4.672s-.011-3.454-.067-4.673A6.407,6.407,0,0,0-2374.5,2077.18Zm-9.014,12.757a5.937,5.937,0,0,1-5.938-5.937,5.937,5.937,0,0,1,5.938-5.937,5.937,5.937,0,0,1,5.937,5.938A5.937,5.937,0,0,1-2383.513,2089.937Zm6.172-10.722a1.388,1.388,0,0,1-1.388-1.387,1.388,1.388,0,0,1,1.388-1.388,1.388,1.388,0,0,1,1.387,1.388A1.387,1.387,0,0,1-2377.341,2079.215Z"
              transform="translate(2403.534 -2063.581)"
            />
            <path
              d="M-2267.542,2196.123a3.855,3.855,0,0,0-3.855,3.854,3.855,3.855,0,0,0,3.855,3.854,3.854,3.854,0,0,0,3.854-3.854A3.854,3.854,0,0,0-2267.542,2196.123Z"
              transform="translate(2287.563 -2179.558)"
            />
            <path
              d="M-2600.864,1838.041a20,20,0,0,0-20,20,20,20,0,0,0,20,20,20,20,0,0,0,20-20A20,20,0,0,0-2600.864,1838.041Zm11.514,25.186a8.486,8.486,0,0,1-.537,2.807,5.665,5.665,0,0,1-1.333,2.048,5.658,5.658,0,0,1-2.048,1.334,8.486,8.486,0,0,1-2.807.537c-1.233.057-1.627.07-4.768.07s-3.534-.013-4.767-.07a8.488,8.488,0,0,1-2.807-.537,5.661,5.661,0,0,1-2.048-1.334,5.666,5.666,0,0,1-1.334-2.048,8.468,8.468,0,0,1-.537-2.807c-.057-1.234-.07-1.627-.07-4.767s.013-3.534.07-4.768a8.466,8.466,0,0,1,.537-2.807,5.669,5.669,0,0,1,1.334-2.048,5.657,5.657,0,0,1,2.048-1.334,8.5,8.5,0,0,1,2.807-.538c1.233-.057,1.627-.07,4.767-.07s3.534.013,4.768.07a8.494,8.494,0,0,1,2.807.538,5.655,5.655,0,0,1,2.048,1.334,5.668,5.668,0,0,1,1.333,2.048,8.484,8.484,0,0,1,.537,2.807c.056,1.233.07,1.627.07,4.768S-2589.293,1861.994-2589.35,1863.227Z"
              transform="translate(2620.864 -1838.041)"
            />
          </svg>
        </a>
        <a
          href="https://vimeo.com/user43489698"
          target="_blank"
          className="mr-2 transform hover:scale-105"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39.998"
            height="39.998"
            viewBox="0 0 39.998 39.998"
          >
            <g transform="translate(1040.576 -677.415)">
              <path d="M-1020.577,677.415a20,20,0,0,0-20,20,20,20,0,0,0,20,20,20,20,0,0,0,20-20A20,20,0,0,0-1020.577,677.415Zm14.138,13.419q-.188,4.133-5.773,11.32-5.771,7.506-9.768,7.506-2.473,0-4.186-4.572-1.142-4.19-2.285-8.38-1.269-4.57-2.726-4.572a8.776,8.776,0,0,0-2.222,1.334l-1.331-1.716q2.093-1.839,4.13-3.685,2.8-2.414,4.195-2.543,3.3-.317,4.068,4.519.825,5.219,1.144,6.49.952,4.33,2.1,4.329.889,0,2.67-2.808a11.081,11.081,0,0,0,1.906-4.275q.253-2.425-1.906-2.426a5.272,5.272,0,0,0-2.1.464q2.086-6.836,7.973-6.647Q-1006.187,685.3-1006.439,690.834Z" />
            </g>
          </svg>
        </a>
        <a
          href="https://mastodon.social/@instrumentinventorsinitiative"
          target="_blank"
          className="mr-2 transform hover:scale-105"
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20 0C31.0378 0 40 8.95023 40 20C40 31.0378 31.0498 40 20 40C8.96219 40 0 31.0498 0 20C0 8.96219 8.95023 0 20 0ZM30.5083 13.7099C30.182 11.2842 28.0677 9.37242 25.5614 9.00203C25.1386 8.93945 23.5366 8.71164 19.8254 8.71164H19.7977C16.0855 8.71164 15.2892 8.93945 14.8664 9.00203C12.4298 9.36219 10.2048 11.0798 9.66492 13.5344C9.40531 14.7431 9.37758 16.0834 9.42586 17.3126C9.49453 19.0755 9.50789 20.8353 9.66812 22.591C9.77875 23.7573 9.97181 24.9143 10.2459 26.0533C10.7589 28.1567 12.8362 29.9073 14.8715 30.6216C17.0504 31.3663 19.3936 31.4899 21.6388 30.9786C21.8852 30.9213 22.1293 30.8546 22.3706 30.7785C22.9166 30.6051 23.556 30.4113 24.0262 30.0705C24.0326 30.0657 24.0378 30.0595 24.0415 30.0524C24.0452 30.0453 24.0473 30.0375 24.0477 30.0295V28.3281C24.0475 28.3206 24.0458 28.3132 24.0425 28.3065C24.0374 28.2964 24.0291 28.2884 24.0189 28.2835C24.0087 28.2787 23.9972 28.2774 23.9862 28.2798C22.5476 28.6235 21.0735 28.7957 19.5945 28.793C17.0492 28.793 16.3647 27.5852 16.1688 27.0825C16.0112 26.648 15.9111 26.1947 15.871 25.7341C15.8706 25.7264 15.872 25.7186 15.8752 25.7116C15.8783 25.7044 15.883 25.6982 15.889 25.6933C15.895 25.6884 15.9021 25.685 15.9097 25.6834C15.9173 25.6818 15.9251 25.6819 15.9326 25.6838C17.3471 26.0251 18.7972 26.1973 20.2523 26.197C20.6023 26.197 20.9513 26.197 21.3013 26.1876C22.7647 26.1466 24.3073 26.0716 25.7471 25.7905C25.7831 25.7834 25.8191 25.7772 25.8498 25.768C28.1211 25.3318 30.2825 23.963 30.5021 20.4967C30.5102 20.3602 30.5309 19.0673 30.5309 18.9258C30.5318 18.4445 30.6858 15.5118 30.5083 13.7099ZM26.9101 16.4353V22.4618H24.5219V16.6128C24.5219 15.3815 24.0087 14.7534 22.9649 14.7534C21.8173 14.7534 21.2427 15.4965 21.2427 16.9637V20.1653H18.869V16.9637C18.869 15.4965 18.2931 14.7534 17.1457 14.7534C16.1081 14.7534 15.5898 15.3815 15.5898 16.6128V22.4618H13.2027V16.4353C13.2027 15.204 13.5171 14.2257 14.1458 13.5005C14.7945 12.7771 15.6452 12.4057 16.7013 12.4057C17.9236 12.4057 18.8473 12.8757 19.463 13.8145L20.0573 14.812L20.6527 13.8145C21.2684 12.8757 22.1921 12.4057 23.4123 12.4057C24.4674 12.4057 25.3181 12.7771 25.9688 13.5005C26.597 14.2251 26.9107 15.2034 26.9101 16.4353Z"
              fill="black"
            />
          </svg>
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;
